/**
 * Newsletter Form Tracking - Google Analytics Enhanced Ecommerce
 * Tracks form_start and form_submit events for Klaviyo newsletter forms
 */

class NewsletterFormTracker {
  constructor() {
    this.formStarted = false;
    this.init();
  }

  /**
   * Initialize the newsletter form tracker
   */
  init() {
    this.observeKlaviyoForm();
  }

  /**
   * Observe for Klaviyo form to load
   */
  observeKlaviyoForm() {
    const observer = new MutationObserver((mutations, observer) => {
      const targetElement = document.querySelector('.klaviyo-form-SHskm9');
      if (targetElement) {
        // Disconnect the observer once the element is found
        observer.disconnect();
        this.setupFormTracking(targetElement);
      }
    });

    // Observe changes in the entire document
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /**
   * Setup form tracking for the Klaviyo form
   * @param {HTMLElement} targetElement - The Klaviyo form container
   */
  setupFormTracking(targetElement) {
    // Wait for Klaviyo form to fully initialize
    setTimeout(() => {
      this.trackFormStart(targetElement);
    }, 1000);
  }

  /**
   * Track form start and form submit events
   * @param {HTMLElement} targetElement - The Klaviyo form container
   */
  trackFormStart(targetElement) {
    // Try to find form elements directly (this works for current Klaviyo setup)
    this.trackDirectForm(targetElement);
  }



  /**
   * Track form directly
   * @param {HTMLElement} targetElement - The form container
   */
  trackDirectForm(targetElement) {
    const form = targetElement.querySelector('form');
    if (form) {
      this.attachFormListeners(form, document);
    }
  }

  /**
   * Attach event listeners to form elements
   * @param {HTMLElement} form - The form element
   * @param {Document} doc - The document context
   */
  attachFormListeners(form, doc) {
    // Track form start
    const inputs = form.querySelectorAll('input[type="email"], textarea, select');
    inputs.forEach(input => {
      input.addEventListener('focus', () => {
        this.fireFormStartEvent();
      });
    });

    // Track form submission
    form.addEventListener('submit', () => {
      this.handleFormSubmission(form);
    });

    // Also track submit button clicks as fallback
    const submitButtons = form.querySelectorAll('button[type="submit"], input[type="submit"], button');
    submitButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.handleFormSubmission(form);
      });
    });
  }



  /**
   * Fire the form start event
   */
  fireFormStartEvent() {
    if (!this.formStarted) {
      this.formStarted = true;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "form_start",
        form_id: "klaviyo-newsletter",
        form_name: "Newsletter Signup",
        form_type: "newsletter",
        form_destination: window.location.href
      });
    }
  }

  /**
   * Handle form submission
   * @param {HTMLElement|null} form - The form element (if accessible)
   */
  handleFormSubmission(form) {
    let submitText = 'Subscribe';
    
    // Try to get submit button text
    if (form) {
      const submitButton = form.querySelector('[type="submit"], button');
      if (submitButton) {
        submitText = submitButton.textContent.trim() || 'Subscribe';
      }
    }

    // For Klaviyo forms, we'll track the submission immediately
    // since detecting success is complex due to their implementation
    this.fireFormSubmitEvent(submitText);
  }

  /**
   * Fire the form submit event
   * @param {string} submitText - The submit button text
   */
  fireFormSubmitEvent(submitText) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "form_submit",
      form_id: "klaviyo-newsletter",
      form_name: "Newsletter Signup",
      form_type: "newsletter",
      form_destination: window.location.href,
      form_submit_text: submitText
    });
  }
}

// Initialize the newsletter tracker when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  new NewsletterFormTracker();
}); 